"use strict";

var _ = require('underscore');

module.exports = {
  TYPES: _.mapObject(_.invert([
    'TEXT',
    'DROPDOWN',
    'CHECKBOX',
    'RADIOBUTTON',
    'UNIDROPDOWN',
    'PASSWORD',
    'NUMBER',
    'TEXTAREA',
    'TEXT_SUGGEST',
    'TAGS',
    'DATE',
  ]), parseInt)
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/input-types.js
 ** module id = 315
 ** module chunks = 0 1 6
 **/